import { alpha, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  bodyRow: {
    alignSelf: 'stretch',
    background: alpha('#fdfdfe', 0.1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
    padding: '0 10px 0 0',
    borderRadius: '6px',
    height: '43px',
  },
  selectModeStyle: {
    color: '#fdfdfe',
    fontSize: '16px',
    lineHeight: '1',
    fontWeight: 'normal',
    width: '100%',
    wordWrap: 'break-word',
    minWidth: 0,
    padding: '10px 16px',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  iconButton: {
    color: alpha('#fdfdfe', 0.7),
  },
  selectStyle: {
    fontSize: '14px',
    background: 'transparent',
    position: 'relative',
    '& .select-trigger': {
      color: '#FFFFFF99 !important',
      background: 'transparent',
      border: 'none !important',
      outline: 'none !important',
    },
    '& .select-arrow-icon': {
      color: '#FFFFFF99 !important',
      fill: '#FFFFFF99 !important',
      width: '24px !important',
      height: '24px !important',
      right: 0,
    },
    '& .select-placeholder': {
      color: '#FFFFFF99 !important',
    },
  },
  optionsList: {
    color: '#FFFFFF99 !important',
    WebkitTextFillColor: '#fdfdfe !important',
    backgroundColor: '#513E52 !important',
  },
  selectOption: {
    fontSize: '15px !important',
    padding: '6px 16px !important',
    height: '48px !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
  },
  divider: {
    margin: '0 10px',
    background: '#AAA2AA',
    width: '1px',
  },
  disabledRow: {
    opacity: 0.5,
  },
  numericRow: {
    padding: 0,
  },
  numericRowExpanded: {
    height: 'auto',
  },
}));
